import { Pipe, PipeTransform } from '@angular/core';
import { CommonDataSetAction, ItemAttrListDataSet } from '@mri/types';

@Pipe({
  name: 'tableDataSetDisable',
})
export class TableDataSetDisablePipe implements PipeTransform {

  transform(actions: CommonDataSetAction, prop: ItemAttrListDataSet): unknown {
    if(!actions.disableWhen) return false;

    return actions.disableWhen(prop)
  }

}
